import { AccountInfo } from "@azure/msal-browser";
import { loginRequest, msalInstance } from "./authConfig";

export const authService = {
  async initialize(): Promise<void> {
    await msalInstance.initialize();
  },

  async login(): Promise<void> {
    await msalInstance.loginRedirect(loginRequest);
  },

  async logout(): Promise<void> {
    await msalInstance.logoutRedirect();
  },

  /**
   * Gets an access token for a specific account.
   * All Graph API calls MUST use this method with an explicit account.
   *
   * @param account - The MSAL account to get token for
   * @param scopes - OAuth scopes (defaults to Graph API scopes)
   * @returns Access token string
   * @throws Error if account is not found in MSAL instance, ou l'erreur MSAL
   *         si l'acquisition silencieuse échoue — jamais de chaîne vide.
   */
  async getAccessToken(
    account: AccountInfo,
    scopes: string[] = loginRequest.scopes
  ): Promise<string> {
    if (!account) {
      throw new Error(
        "No account provided! All Graph API calls must specify an account."
      );
    }

    // Find the corresponding MSAL account
    const msalAccount = msalInstance
      .getAllAccounts()
      .find((acc) => acc.homeAccountId === account.homeAccountId);

    if (!msalAccount) {
      throw new Error(`Account ${account.username} not found in MSAL instance`);
    }

    // Aucune redirection en catimini, aucune chaîne vide : la redirection
    // quittait la page au milieu d'un envoi, et le jeton vide faisait partir
    // le client Graph avec un en-tête d'autorisation creux — un échec
    // impossible à lire. L'erreur MSAL remonte telle quelle : c'est elle qui
    // nomme la cause, jusqu'au code AADSTS.
    const response = await msalInstance.acquireTokenSilent({
      scopes,
      account: msalAccount,
    });
    return response.accessToken;
  },
};
